import { inject, Injectable } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

@Injectable({
    providedIn: "root",
})
export class InternalNavigationService {
    private readonly router = inject(Router);
    private activatedRoute = inject(ActivatedRoute);

    stockCooperativeShareInfopageUrl(unitId: number): void {
        this.router.navigate(["/infopage/functionalunit", unitId]);
    }

    navigateToEnergyCalculation(unitId: number, address?: string, returnTo?: string): void {
        const returnPath = returnTo ? returnTo : window.location.href;

        this.router.navigate(["/energy", unitId], {
            queryParams: {
                returnTo: returnPath,
                address: address ? address : "",
            },
        });
    }

    // A param set to null or undefined is removed from the url
    updateUrlParams(queryParams: Record<string, string | number | boolean | null | undefined>): void {
        const currentPath = this.router.url.split("?")[0];
        this.router.navigate([currentPath], { queryParams, queryParamsHandling: "merge" });
    }

    getLoadRedirectWindow(): Window {
        return window.open("reports/loading", "_blank");
    }
}
